import { ZfStack } from '@zafire/react';
import moment from 'moment';
import type { FunctionComponent } from 'react';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { AddEventButton } from '../components/lifeplan/AddEventButton';
import { TimeLineEvents } from '../components/lifeplan/TimelineEvents';
import { useLayout } from '../contexts/layout-context';
import { useElementHeight } from '../hooks/useElementHeight';

const MAX_YEAR_RANGE = 53;

export const LifeEventsScreen: FunctionComponent = () => {
    const { t } = useTranslation();
    const { totalNavbarHeight } = useLayout();
    const headerRef = useRef<HTMLZfStackElement>(null);
    const headerHeight = useElementHeight(headerRef);

    const minDateFrom = moment().subtract(3, 'year');
    const maxDateTo = moment(minDateFrom).add(MAX_YEAR_RANGE, 'year');

    return (
        <ZfStack direction="column" className="life-plan-screen">
            <ZfStack ref={headerRef} direction="row" alignment="center" justify="space-between" className="life-plan-screen__header">
                <h3>{t('lifeplanTitle')}</h3>
                <AddEventButton />
            </ZfStack>
            <div className="life-plan-screen__timeline-events" style={{ maxHeight: `calc(100vh - ${headerHeight}px - ${totalNavbarHeight}px)` }}>
                <TimeLineEvents dateFrom={minDateFrom} dateTo={maxDateTo} />
            </div>
        </ZfStack>
    );
};
